module.exports = __webpack_public_path__ + "static/media/language.507a2259.png";